import { render } from "./BannerCars.vue?vue&type=template&id=1279798a"
import script from "./BannerCars.vue?vue&type=script&lang=js"
export * from "./BannerCars.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__